export class ListMPAOperationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operations",
            "baseName": "operations",
            "type": "Array<MPAOperationInfo>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMPAOperationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
